"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = exports.DEFAULT_SPACING = exports.DEFAULT_HEIGHTS = exports.DEFAULT_FONT_SIZES = exports.DEFAULT_FONTS = exports.DEFAULT_ELEVATIONS = exports.DEFAULT_COLOURS = exports.DEFAULT_BREAKPOINTS = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _buttonStyles = _interopRequireDefault(require("./buttonStyles"));

var DEFAULT_COLOURS = {
  primary: ["#ff00aa", "#ff33bb", "#ff66cc", "#ff99dd", "#ffccee", "#ffe6f7"],
  secondary: ["rgba(66, 66, 66, 1)", "rgba(66, 66, 66, 0.6)", "rgba(66, 66, 66, 0.38)", "rgba(66, 66, 66, 0.16)", "rgba(66, 66, 66, 0.12)", "rgba(66, 66, 66, 0.08)"],
  dark: ["#000000", "#0d0d0d", "#1a1a1a", "#282828", "#353535", "#424242", "#686868", "#8e8e8e"],
  error: ["#bf4630", "#cc6b59", "#d99083", "#e5b5ac", "#f2dad6"],
  grey: ["rgba(245, 245, 245, 1)"],
  light: ["#ffffff", "#e5e6e6", "#cbcccc", "#b2b3b3", "#989999", "#7f8080", "#666666", "#4c4d4d"]
};
exports.DEFAULT_COLOURS = DEFAULT_COLOURS;
var DEFAULT_FONTS = {
  serif: "'Roboto Slab'",
  sansSerif: "Roboto",
  monospace: "'Roboto Mono'"
};
exports.DEFAULT_FONTS = DEFAULT_FONTS;
var DEFAULT_ELEVATIONS = ["none", "0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)", "0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)", "0 3px 3px -2px rgba(0,0,0,.2),0 3px 4px 0 rgba(0,0,0,.14),0 1px 8px 0 rgba(0,0,0,.12)", "0 2px 4px -1px rgba(0,0,0,.2),0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12)", "0 3px 5px -1px rgba(0,0,0,.2),0 5px 8px 0 rgba(0,0,0,.14),0 1px 14px 0 rgba(0,0,0,.12)", "0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12)", "0 4px 5px -2px rgba(0,0,0,.2),0 7px 10px 1px rgba(0,0,0,.14),0 2px 16px 1px rgba(0,0,0,.12)", "0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)", "0 5px 6px -3px rgba(0,0,0,.2),0 9px 12px 1px rgba(0,0,0,.14),0 3px 16px 2px rgba(0,0,0,.12)", "0 6px 6px -3px rgba(0,0,0,.2),0 10px 14px 1px rgba(0,0,0,.14),0 4px 18px 3px rgba(0,0,0,.12)", "0 6px 7px -4px rgba(0,0,0,.2),0 11px 15px 1px rgba(0,0,0,.14),0 4px 20px 3px rgba(0,0,0,.12)", "0 7px 8px -4px rgba(0,0,0,.2),0 12px 17px 2px rgba(0,0,0,.14),0 5px 22px 4px rgba(0,0,0,.12)", "0 7px 8px -4px rgba(0,0,0,.2),0 13px 19px 2px rgba(0,0,0,.14),0 5px 24px 4px rgba(0,0,0,.12)", "0 7px 9px -4px rgba(0,0,0,.2),0 14px 21px 2px rgba(0,0,0,.14),0 5px 26px 4px rgba(0,0,0,.12)", "0 8px 9px -5px rgba(0,0,0,.2),0 15px 22px 2px rgba(0,0,0,.14),0 6px 28px 5px rgba(0,0,0,.12)", "0 8px 10px -5px rgba(0,0,0,.2),0 16px 24px 2px rgba(0,0,0,.14),0 6px 30px 5px rgba(0,0,0,.12)", "0 8px 11px -5px rgba(0,0,0,.2),0 17px 26px 2px rgba(0,0,0,.14),0 6px 32px 5px rgba(0,0,0,.12)", "0 9px 11px -5px rgba(0,0,0,.2),0 18px 28px 2px rgba(0,0,0,.14),0 7px 34px 6px rgba(0,0,0,.12)", "0 9px 12px -6px rgba(0,0,0,.2),0 19px 29px 2px rgba(0,0,0,.14),0 7px 36px 6px rgba(0,0,0,.12)", "0 10px 13px -6px rgba(0,0,0,.2),0 20px 31px 3px rgba(0,0,0,.14),0 8px 38px 7px rgba(0,0,0,.12)", "0 10px 13px -6px rgba(0,0,0,.2),0 21px 33px 3px rgba(0,0,0,.14),0 8px 40px 7px rgba(0,0,0,.12)", "0 10px 14px -6px rgba(0,0,0,.2),0 22px 35px 3px rgba(0,0,0,.14),0 8px 42px 7px rgba(0,0,0,.12)", "0 11px 14px -7px rgba(0,0,0,.2),0 23px 36px 3px rgba(0,0,0,.14),0 9px 44px 8px rgba(0,0,0,.12)", "0 11px 15px -7px rgba(0,0,0,.2),0 24px 38px 3px rgba(0,0,0,.14),0 9px 46px 8px rgba(0,0,0,.12)"];
exports.DEFAULT_ELEVATIONS = DEFAULT_ELEVATIONS;
var DEFAULT_SPACING = [0, 4, 8, 16, 24, 32, 64, 128, 256, 512];
exports.DEFAULT_SPACING = DEFAULT_SPACING;
var DEFAULT_FONT_SIZES = [0, 10, 12, 14, 16, 18, 20, 24, 34, 48, 60, 96];
exports.DEFAULT_FONT_SIZES = DEFAULT_FONT_SIZES;
var DEFAULT_HEIGHTS = [0, 16, 32, 64, 128, 256];
exports.DEFAULT_HEIGHTS = DEFAULT_HEIGHTS;
var DEFAULT_BREAKPOINTS = [768, 1024];
/**
 * Creates a new theme for use with components in the component library.
 * @param theme A theme object. Uses fallback default values for parts of the theme
 * that aren't definied (e.g. default colours, or default font families).
 */

exports.DEFAULT_BREAKPOINTS = DEFAULT_BREAKPOINTS;

var createTheme = function createTheme(_ref, buttonStyleGenerator) {
  var _ref$colours = _ref.colours,
      colours = _ref$colours === void 0 ? DEFAULT_COLOURS : _ref$colours,
      _ref$space = _ref.space,
      space = _ref$space === void 0 ? DEFAULT_SPACING : _ref$space,
      _ref$fontSizes = _ref.fontSizes,
      fontSizes = _ref$fontSizes === void 0 ? DEFAULT_FONT_SIZES : _ref$fontSizes,
      _ref$fonts = _ref.fonts,
      fonts = _ref$fonts === void 0 ? DEFAULT_FONTS : _ref$fonts,
      _ref$heights = _ref.heights,
      heights = _ref$heights === void 0 ? DEFAULT_HEIGHTS : _ref$heights,
      _ref$breakpoints = _ref.breakpoints,
      breakpoints = _ref$breakpoints === void 0 ? DEFAULT_BREAKPOINTS : _ref$breakpoints,
      _ref$elevations = _ref.elevations,
      elevations = _ref$elevations === void 0 ? DEFAULT_ELEVATIONS : _ref$elevations;

  if (buttonStyleGenerator === void 0) {
    buttonStyleGenerator = _buttonStyles["default"];
  }

  return {
    colors: (0, _extends2["default"])({}, colours),
    space: [].concat(space),
    fontSizes: [].concat(fontSizes),
    fonts: (0, _extends2["default"])({}, fonts),
    heights: [].concat(heights),
    breakpoints: [].concat(breakpoints),
    buttons: buttonStyleGenerator(colours),
    elevations: [].concat(elevations)
  };
};

var _default = createTheme;
exports["default"] = _default;